<template>
  <table aria-labelledby="table-heading-azmerit">
		<caption id="table-heading-azmerit">A Z merit % passing 2016 - 2017</caption>
		<thead>
			<tr>
				<th>Category</th>
				<th>{{ s1Name }}</th>
				<th>{{ s2Name }}</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>English Language Arts</td>
				<td>{{ s1Data.isNull ? NA : s1Data.ela }}</td>
				<td>{{ s2Data.isNull ? NA : s2Data.ela }}</td>
			</tr>
			<tr>
				<td>Mathematics</td>
				<td>{{ s1Data.isNull ? NA : s1Data.math }}</td>
				<td>{{ s2Data.isNull ? NA : s2Data.math }}</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
	export default {
		props: ['s1Name', 's2Name', 's1Data', 's2Data'],
		data() {
			return {
				NA: 'data point unavailable'
			}
		}
	}
</script>
